import script from "./refuseExamine.vue?vue&type=script&setup=true&lang=js"
export * from "./refuseExamine.vue?vue&type=script&setup=true&lang=js"

import "./refuseExamine.vue?vue&type=style&index=0&id=aa573d5a&lang=scss"

const __exports__ = script;

export default __exports__